import React from 'react';
import styles from './DigitalCard.module.css';
import ChevronIcon from '../../icons/chevronIcon';
import { useTranslation } from 'react-i18next';
import AdvantageIcon from '../../icons/AdvantageIcon';
import { useHistory } from 'react-router-dom';

const DigitalCard = ({ name, category }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const redirectLoyaltyCard = () => {
    history.push('/loyalty-card');
  };
  return (
    <div  onClick={() => redirectLoyaltyCard()}  className={`card ${styles.cardContainer}`}>
      <div className='row'>
        <div className='col pr-0'>
          <div className='p-3'>
            <div className='fw-semibold font-large'>{name}</div>
            <div className='font-smaller'>Advantage Program</div>

            <div className='text-tertiary d-flex justify-content-between mt-3'>
              <div className='font-smaller'>
                {t('consumer.goToMyCard')}
              </div>
              <div>
                <ChevronIcon size={18} />
              </div>
            </div>
          </div>
        </div>
        <div className='col-auto'>
          <div className={styles.advantageCategory}>
            <AdvantageIcon color='#000' size={28} />
            <div className='mt-1'>{t("member")}</div>
            <div>{category}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalCard;
